var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToCorrect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_550_7336)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99967 3.33332V1.84165C9.99967 1.46665 9.54967 1.28332 9.29134 1.54998L6.95801 3.87498C6.79134 4.04165 6.79134 4.29998 6.95801 4.46665L9.28301 6.79165C9.54967 7.04998 9.99967 6.86665 9.99967 6.49165V4.99998C12.758 4.99998 14.9997 7.24165 14.9997 9.99998C14.9997 10.6583 14.8747 11.3 14.633 11.875C14.508 12.175 14.5997 12.5167 14.8247 12.7417C15.2497 13.1667 15.9663 13.0167 16.1913 12.4583C16.4997 11.7 16.6663 10.8667 16.6663 9.99998C16.6663 6.31665 13.683 3.33332 9.99967 3.33332ZM9.99967 15C7.24134 15 4.99967 12.7583 4.99967 9.99998C4.99967 9.34165 5.12467 8.69998 5.36634 8.12498C5.49134 7.82498 5.39967 7.48332 5.17467 7.25832C4.74967 6.83332 4.03301 6.98332 3.80801 7.54165C3.49967 8.29998 3.33301 9.13332 3.33301 9.99998C3.33301 13.6833 6.31634 16.6667 9.99967 16.6667V18.1583C9.99967 18.5333 10.4497 18.7167 10.708 18.45L13.033 16.125C13.1997 15.9583 13.1997 15.7 13.033 15.5333L10.708 13.2083C10.4497 12.95 9.99967 13.1333 9.99967 13.5083V15Z",
    fill: "#FF66A9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_550_7336"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToCorrect);
export default __webpack_public_path__ + "static/media/toCorrect.d743af06.svg";
export { ForwardRef as ReactComponent };